import { BANK131_PAYMENT_FORM_PATH, CONTINUE_WITH_PI_PATH, GAME_STORE_PATH } from "./paths";

export const SINGLE_GAME_CONTINUE_WITH_PI_ROUTE = CONTINUE_WITH_PI_PATH;
export const SINGLE_GAME_BANK131_PAYMENT_FORM_ROUTE = BANK131_PAYMENT_FORM_PATH;
export const SINGLE_GAME_STORE_ROUTE = GAME_STORE_PATH;
